import React from 'react'
import { History } from 'history'

import SiteWrapper from '../components/sitewrapper'
import Layout from '../components/layout'
import Intro from '../components/intro'
import CampaignCodesAdministration from '../components/campaign-codes-administration'
import CampaignIntroContent from '../components/campaign-intro-content'
import GeneratorUpdatesRequestList from '../components/generator-updates-request-list'

interface Props {
  history: History
}

export default function EditCampaignCodes({
  history,
}: Props): React.ReactElement {
  return (
    <SiteWrapper>
      <Layout width={1200}>
        <Intro title="Edit campaign links settings">
          <CampaignIntroContent>
            <p>
              Add new dropdown options below or edit your code structure and
              validation rules.
            </p>
          </CampaignIntroContent>
        </Intro>
        <GeneratorUpdatesRequestList />
        <CampaignCodesAdministration history={history} />
      </Layout>
    </SiteWrapper>
  )
}
